import conscientpark from "../../../../public/projects/Conscient/images/projects/p.webp";
import logo from "../../../../public/projects/Conscient/images/logo/logo.png";

//Parq
import overviewImage_parq from "../../../../public/projects/Conscient/images/parq/Overview/1.webp";
import bannerDesktopImage_parq from "../../../../public/projects/Conscient/images/parq/Banner/1.webp";
import bannerMobileImage_parq from "../../../../public/projects/Conscient/images/parq/Banner/2.webp";
import siteVisitBannerImage_parq from "../../../../public/projects/Conscient/images/parq/SiteVisitBanner/1.webp";
import Location_parq from "../../../../public/projects/Conscient/images/parq/Location/L1.webp";
import Hightlights_parq from "../../../../public/projects/Conscient/images/parq/Highlights/1.webp";
import image1BHK_parq from "../../../../public/projects/Conscient/images/parq/floorplan/1.webp";
import image2BHK_parq from "../../../../public/projects/Conscient/images/parq/floorplan/2.webp";
import location_parq from "../../../../public/projects/Conscient/images/parq/Overview/l.png";
import cal_parq from "../../../../public/projects/Conscient/images/parq/Overview/c.png";
import newlaunch_parq from "../../../../public/projects/Conscient/images/parq/Overview/n.png";
import g1_parq from "../../../../public/projects/Conscient/images/parq/Gallery/1.webp";
import g2_parq from "../../../../public/projects/Conscient/images/parq/Gallery/2.webp";
import g3_parq from "../../../../public/projects/Conscient/images/parq/Gallery/3.webp";
import g4_parq from "../../../../public/projects/Conscient/images/parq/Gallery/4.webp";
import g5_parq from "../../../../public/projects/Conscient/images/parq/Gallery/5.webp";

export const developersConscient = {
  name: `Conscient Properties in Gurugram`,
  properties: [
    {
      name: "Conscient - Parq",
      image: conscientpark,
      price: "On Request",
      location: "Sector 80",
      state: "Gurugram",
      developer: "Conscient",
      bed: "1 - 3 BHK",
      size: "....",
      url: `/conscient-parq-sector-80-gurugram`,
      form: {
        source_id: 11,
        api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        sub_source_id: 130,
        builder_id: `103`,
        project_id: `477`,
        subject: "M3M Altitude", // Add or update the subject here
        to_email: "jatin.rohilla@propertystation.in",
      },
    },
    {
      name: "Conscient - Elevate Reserve",
      image: conscientpark,
      price: "On Request",
      location: "Sector 62",
      projectlocation: "Golf Course Extension Road",
      bed: "3 - 4 BHK",
      size: "....",
      state: "Gurugram",
      developer: "Conscient",
      url: ``,
      form: {
        source_id: 11,
        api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        sub_source_id: 130,
        builder_id: `103`,
        project_id: `477`,
        subject: "M3M Altitude", // Add or update the subject here
        to_email: "jatin.rohilla@propertystation.in",
      },
    },
  ],
};

export const headerData = {
  logo: logo,
  data: {
    experience: `1990`,
    projects: `118`,
    ongoingprojects: `10`,
  },
  about: `
  

At Conscient, we aim to create what we uniquely can give to the world, not just buildings or homes, but a lifestyle that epitomizes soulful living. Getting the basics of creation right, upholding high standards of delivery and reliability, and creating more value than profits has helped us achieve what we most believe in - Excellence.
This belief, in conjunction with extensive planning and meticulous designing has so far helped us in delivering over ~ 12,000 homes across Delhi-NCR, Dehradun & Goa in the last 4 decades.
In pursuit of excellence, Conscient has partnered with world-renowned architects, designers and consultants, currently helping the company transform over 7 million square feet of space into world class Premium Condominiums, Luxury Villas, Institutional, Commercial/Retail and Value Housing.
  `,
};

export const projectsconscient = {
  conscientparq: {
    bannerdata: {
      bannerDesktopImage:bannerDesktopImage_parq,
      bannerMobileImage:bannerMobileImage_parq,
      textOverlay: "",
      data: {
        title: "Conscient Parq",
        subtitle: "Sector 80, Gurgaon",
        starting_price: "₹ 3.2 Cr*",
        rerano:"GGM/818/550/2024/45",
        payment_plan: "30 : 40 : 30",
        status: "New Launch",
      },
    },
    overview: {
      heading: "Discover Luxury Living at Conscient Parq  ",
      description: [
        `Conscient Parq in Gurgaon offers the perfect blend of modern apartments and luxurious villas, catering to diverse living needs.
        Designed for both comfort and space efficiency, the apartments provide a contemporary aesthetic while ensuring a seamless and convenient 
        lifestyle with essential amenities.
For those seeking exclusivity, the spacious villas at Conscient Parq deliver the ideal balance of elegance and privacy. With premium finishes and
 thoughtfully planned layouts, these independent homes offer ample space for both relaxation and entertainment, making them a perfect choice for
  discerning families.
Nestled in a vibrant community, Conscient Parq seamlessly merges sophistication with convenience, making it an attractive option for individuals
 and families alike. Whether you prefer the modern appeal of the apartments or the luxurious ambiance of the villas, this development has something
  for everyone.
Experience a lifestyle where style meets comfort, right in the heart of Gurgaon's dynamic landscape. Choose Conscient Parq as your next home and 
elevate your living experience!`,
      ],
      image: overviewImage_parq,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: location_parq,
          title: "₹ 3.2 Cr*",
          subtitle: "Starting Price",
        },
        {
          iconClass: cal_parq,
          title: "30:40:30",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunch_parq,
          title: "New Launch",
          subtitle: "Status",
        },
      ],
    },

    sitevisit: {
      image: siteVisitBannerImage_parq,
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK",
          area: "1063 - 1743.7 sq. ft.",
          price: "₹ 3.2 - 5.25 Cr*",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK",
          area: "1537 - 1853.9 sq. ft.",
          price: "₹ 3.72 - 4.49 Cr*",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK",
        area: "1063 - 1743.7 sq. ft.",
        price: "₹ 3.2 - 5.25 Cr*",
        image: image1BHK_parq,
      },
      {
        type: "4 BHK",
        area: "1537 - 1853.9 sq. ft.",
        price: "₹ 3.72 - 4.49 Cr*",
        image: image2BHK_parq,
      },
    ],

    highlights: {
      images: Hightlights_parq,
      tagline: "Highlights",
      features: [
        "36 Feet Entrance Lobby.",
        "Club House - 50k Sqft.",
        "Ceiling Height - 10 Feet.",
        "2.2 Acre Central Green Area.",
        "Other Charges Ifms 1lac + Gst+ Registry.",
      ],
    },

    location: {
      image: Location_parq,
      data:[
        {
          airport:{
            distance_time:"30 Kms",
            name:"Delhi airport"
          },
          school:{
            distance_time:"3 Kms",
            name:"Jai Bharti School"
          },
          railwayormetro:{
            distance_time:"17.6 Kms",
            name:"Sector 55-56 Metro Station"
          },
          hospital:{
            distance_time:"4.4 Kms",
            name:"Yashlok Medical Centre"
          },
          mall:{
            distance_time:"1 Kms",
            name:"Big Bazzar"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image:g1_parq },
        { image:g2_parq},
        { image:g3_parq },
        { image:g4_parq },
        { image:g5_parq },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in Conscient Parq, kindly share more details.",
    },

    faq: [
      {
        question: "What makes Conscient Parq, a standout choice for homebuyers?",
        answer: `Conscient Parq is a premium residential project in Sector 80, Gurgaon, developed by Conscient Group. It offers luxurious apartments with top-notch amenities and a prime location.`,
      },
      {
        question: "Where is Conscient Parq located?",
        answer: `The project is situated in Sector 80, Gurgaon, close to NH-8 and well-connected to major business hubs, shopping centers, and educational institutions.`,
      },
      {
        question: "What types of residences are available in Conscient Parq?",
        answer: `Conscient Parq offers spacious 2 BHK and 3 BHK apartments with modern interiors, premium fittings, and ample natural light.`,
      },
      {
        question: "What are the key amenities provided in Conscient Parq?",
        answer: `The project includes amenities such as a clubhouse, swimming pool, gym, landscaped gardens, kids’ play area, jogging track, and 24/7 security.`,
      },
      {
        question: "What is the price range of apartments in Conscient Parq?",
        answer: `The pricing of 3 BHK(1063 - 1743.7 sq. ft.) = ₹ 3.2 Cr* and 4 BHK(1537 - 1853.9 sq. ft.) = ₹ 4.4 Cr*.`,
      },
      {
        question: "Who is the developer of Conscient Parq?",
        answer: `Conscient Parq is developed by Conscient Group, a well-known real estate developer with a strong presence in Gurgaon and other cities.`,
      },
      {
        question: "What is the RERA registration status of Conscient Parq?",
        answer: `The project is RERA-approved, ensuring transparency and legal compliance.`,
      },
      {
        question: "Is Conscient Parq a gated community?",
        answer: `Yes, it is a secure gated community with 24/7 security, CCTV surveillance, and controlled access points.`,
      },
      {
        question: "How is the connectivity of Conscient Parq?",
        answer: `The project offers excellent connectivity via NH-8, Dwarka Expressway, and Southern Peripheral Road. It is also near major business hubs like Cyber City and Golf Course Road.`,
      },
      {
        question: "Are there schools and hospitals near Conscient Parq?",
        answer: `Yes, reputed schools like DPS and St. Xavier’s are nearby, along with hospitals such as Medanta and Artemis for quality healthcare services.`,
      },
    ],
    similar: {
      properties: [
       
        {
          name: "Conscient - Elevate Reserve",
          image: conscientpark,
          price: "On Request",
          location: "Sector 62",
          projectlocation: "Golf Course Extension Road",
          bed: "3 - 4 BHK",
          size: "....",
          state: "Gurugram",
          developer: "Conscient",
          url: ``,
          form: {
            source_id: 11,
            api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
            api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "M3M Altitude", // Add or update the subject here
            to_email: "jatin.rohilla@propertystation.in",
          },
        },
      ],
    },
    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
       api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
       source_id: 11,
       sub_source_id: 130,
       builder_id: `103`,
       project_id: `477`,
       subject: "Property Station enquiry", // Add or update the subject here
       to_email: "leads@gurugram-property.com",
     },
  },
};
